interface ICheckIconProps {
  color?: string;
  className?: string;
  onClick?: () => void;
}

const CheckIcon: React.FC<ICheckIconProps> = ({
  color,
  className,
  onClick,
}) => (
  <svg
    width="61"
    height="61"
    viewBox="0 0 61 61"
    xmlns="http://www.w3.org/2000/svg" className={className}>
    <g style={{ fill: color || 'var(--tt-dark-purple)' }} fillRule="evenodd">
      <path d="m38.41 25.19 5.02 5.02-20.08 20.08-5.02-5.02z" />
      <path d="m53.47 10.129 5.02 5.02-20.08 20.08-5.02-5.02zM8.29 25.19l-5.02 5.02 20.08 20.08 5.02-5.02z" />
    </g>
  </svg>
);

export default CheckIcon;
